export const puntoVentaInicial = () => ({
  id: 0,
  bActivo: true,
  sPuntoVenta: "",
  iProximoNumero: 1,
  comprobanteTipo_Id: 0,
  bPresentaNumero: true,
  cai: "",
  fechaCAI: null,
  copias: 1,
  impresora_Id: 0,
  usuario_Id: 0,
  bImprimeDetalle: false,
  bImprimeResumen: false,
  sReporteResumen: "",
  sReporteDetalle: "",
});

const entero = (valor, predeterminado = 0) => {
  const numero = Number(valor);
  return Number.isInteger(numero) ? numero : predeterminado;
};

export const normalizarPuntoVenta = (item = {}) => {
  const inicial = puntoVentaInicial();
  return {
  ...inicial,
  ...item,
  id: entero(item.id ?? item.Id),
  bActivo: Boolean(item.bActivo ?? item.BActivo ?? inicial.bActivo),
  sPuntoVenta: String(item.sPuntoVenta ?? item.SPuntoVenta ?? "").trim(),
  iProximoNumero: entero(item.iProximoNumero ?? item.IProximoNumero),
  comprobanteTipo_Id: entero(item.comprobanteTipo_Id ?? item.ComprobanteTipo_Id),
  comprobanteTipo_Descripcion: String(item.comprobanteTipo_Descripcion ?? item.ComprobanteTipo_Descripcion ?? ""),
  bPresentaNumero: Boolean(item.bPresentaNumero ?? item.BPresentaNumero ?? inicial.bPresentaNumero),
  copias: entero(item.copias ?? item.Copias),
  impresora_Id: entero(item.impresora_Id ?? item.Impresora_Id),
  impresora_Descripcion: String(item.impresora_Descripcion ?? item.Impresora_Descripcion ?? ""),
  usuario_Id: entero(item.usuario_Id ?? item.Usuario_Id),
  usuario_Descripcion: String(item.usuario_Descripcion ?? item.Usuario_Descripcion ?? ""),
  cai: String(item.cai ?? item.CAI ?? ""),
  bImprimeDetalle: Boolean(item.bImprimeDetalle ?? item.BImprimeDetalle ?? inicial.bImprimeDetalle),
  bImprimeResumen: Boolean(item.bImprimeResumen ?? item.BImprimeResumen ?? inicial.bImprimeResumen),
  sReporteResumen: String(item.sReporteResumen ?? item.SReporteResumen ?? ""),
  sReporteDetalle: String(item.sReporteDetalle ?? item.SReporteDetalle ?? ""),
  fechaCAI: item.fechaCAI || item.FechaCAI ? String(item.fechaCAI ?? item.FechaCAI).slice(0, 10) : null,
  };
};

export const extraerListaPuntosVenta = (respuesta) => {
  if (Array.isArray(respuesta)) return respuesta;
  if (!respuesta || typeof respuesta !== "object") return [];
  const lista = respuesta.lista ?? respuesta.Lista ?? respuesta.dato ?? respuesta.Dato;
  return Array.isArray(lista) ? lista : [];
};

export const validarPuntoVenta = (item) => {
  if (!String(item.sPuntoVenta || "").trim()) return "El punto de venta es obligatorio.";
  if (entero(item.comprobanteTipo_Id) <= 0) return "El tipo de comprobante es obligatorio.";
  if (entero(item.iProximoNumero) <= 0) return "El próximo número debe ser mayor a cero.";
  if (entero(item.copias, -1) < 0) return "La cantidad de copias no puede ser negativa.";
  return "";
};

export const crearRequestPuntoVenta = ({ EmpresaId, operadorId, pcId, item }) => {
  const puntoVenta = normalizarPuntoVenta(item);
  return {
    EmpresaId,
    operadorId: entero(operadorId),
    pcId: entero(pcId),
    item: {
      id: puntoVenta.id, bActivo: puntoVenta.bActivo, sPuntoVenta: puntoVenta.sPuntoVenta,
      iProximoNumero: puntoVenta.iProximoNumero, comprobanteTipo_Id: puntoVenta.comprobanteTipo_Id,
      bPresentaNumero: puntoVenta.bPresentaNumero, cai: puntoVenta.cai, fechaCAI: puntoVenta.fechaCAI,
      copias: puntoVenta.copias, impresora_Id: puntoVenta.impresora_Id, usuario_Id: puntoVenta.usuario_Id,
      bImprimeDetalle: puntoVenta.bImprimeDetalle, bImprimeResumen: puntoVenta.bImprimeResumen,
      sReporteResumen: puntoVenta.sReporteResumen, sReporteDetalle: puntoVenta.sReporteDetalle,
    },
  };
};
